// Lets any page tell the navbar that the cart changed so the badge refreshes.
export const CART_UPDATED_EVENT = 'app:cart-updated'

export const notifyCartUpdated = () => {
    window.dispatchEvent(new Event(CART_UPDATED_EVENT))
}
